export default __webpack_public_path__ + "static/media/tools-icon.002340f6.svg";